import { toBusinessWallDate } from './businessTime'

export const getWorkerWeeklyInvoice = (timeSheets, now = new Date()) => {
    const monday = toBusinessWallDate(now)
    monday.setDate(monday.getDate() - ((monday.getDay() || 7) - 1))
    monday.setHours(0, 0, 0, 0)
    const end = new Date(monday)
    end.setDate(end.getDate() + 7)
    let total = 0
    let unavailable = false
    for (const row of timeSheets) {
        const date = toBusinessWallDate(row.date)
        if (!row.clockIn || !row.clockOut || !(date >= monday && date < end)) continue
        if (typeof row.workerHoursAmount !== 'number' || !Number.isFinite(row.workerHoursAmount)) {
            unavailable = true
            continue
        }
        total += row.workerHoursAmount
    }
    return unavailable ? null : Math.round(total * 100) / 100
}
